/**
 * Returns the backend base URL for API calls.
 * 
 * On custom domains (e.g. vetneurohelp.com) that proxy to the same app,
 * uses relative paths ("") so cookies stay same-origin.
 * Otherwise uses the build-time REACT_APP_BACKEND_URL.
 */
const buildTimeUrl = process.env.REACT_APP_BACKEND_URL || '';

function getBackendUrl() {
  if (typeof window === 'undefined') return buildTimeUrl;
  
  const currentOrigin = window.location.origin;
  
  // If the browser origin matches the build-time URL, use it as-is
  if (buildTimeUrl && currentOrigin === buildTimeUrl) {
    return buildTimeUrl;
  }
  
  // If we're on a different origin (custom domain), use relative paths
  // so cookies stay same-origin and aren't blocked as third-party
  if (buildTimeUrl && currentOrigin !== buildTimeUrl) {
    return '';
  }
  
  return buildTimeUrl;
}

export const BACKEND_URL = getBackendUrl();
